import React from 'react';
import LoginForm from '../auth/LoginForm';

const SpeakerLogin = () => (
  <LoginForm
    title="Speaker Login"
    subtitle="Enter your credentials to access the speaker portal"
    redirectTo="/speaker/dashboard"
  />
);

export default SpeakerLogin;
